module.exports = __webpack_public_path__ + "3a7f0abe0b3b1fcbcb856fb3d792fe0e.svg";